import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { Theme } from '../../styles/settings/theme'
import { Flex, Content } from '../atoms/Basics'
import ChartTitle from '../atoms/ChartTitle'
import ChartContainer from '../atoms/ChartContainer'
import Subtitle from '../atoms/Subtitle'
import TopicChart from '../molecules/TopicChart'
import { csv } from 'd3-fetch'

const Segment = styled.div`
  background-color: ${(props) => props.theme.colors.black};
  height: 0.5rem;
  border-radius: 50px;
`
const StyledFlex = styled(Flex)`
  :last-child {
    margin-left: 1rem;
  }
`
const TopicContent = styled(Content)`
  flex-wrap: wrap;
`

const Demographics = () => {
  const $ = window.WILDLABS_VARS
  const [gender, setGender] = useState(null)
  useEffect(() => {
    csv('./data/demographicsGender.csv').then(setGender)
  }, [])
  const topics = ['region', 'org', 'role']
  return (
    <ChartContainer>
      <ChartTitle text={$.demog_titles.chartTitle} />
      <Subtitle
        text={$.demog_titles.subtitle}
        size={Theme.fontSizes[4]}
        color={Theme.colors.gray}
      ></Subtitle>
      <Flex>
        {gender?.map((row) => (
          <StyledFlex
            key={row.n}
            flexDirection="column"
            width={`${row.percent * 100}%`}
          >
            <div key={row.percent}>
              <span>
                <b>{row.percent * 100}%</b>
              </span>
              &nbsp;{row.group}
            </div>
            <Segment key={row.group}></Segment>
          </StyledFlex>
        ))}
      </Flex>
      <TopicContent justifyContent="space-between">
        {topics.map((topic) => (
          <TopicChart key={topic} topic={topic}></TopicChart>
        ))}
      </TopicContent>
    </ChartContainer>
  )
}

export default Demographics
